export const SENTRY_DSN: string = "https://c253849669675bea2186d53db49458de@o4510511988342784.ingest.us.sentry.io/4510659358097408";
